import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import React from 'react';
import {useWorkspaceContext} from '../../../context/workspaceContext';
import OccurrenceService from '../../../services/occurrence.service';
import Occurrence from '../../../@types/occurrence';
import {ResourceType} from '../../../@types/resource-type';
import {toast} from 'react-toastify';
import DotdotdotButton from '../../form-components/DotdotdotButton.component';
import DeleteResource from '../modals/DeleteResource.component';
import Box from '@mui/material/Box';
import DuplicateResource from '../modals/DuplicateResource.component';

export default function OccurrenceActionsMenu(props: {
    occurrence: Occurrence
}): React.ReactElement {
    const [confirmDeleteOccurrence, setConfirmDeleteOccurrence] = React.useState<boolean>(false);
    const [confirmDuplicateOccurrence, setConfirmDuplicateOccurrence] = React.useState<boolean>(false);

    const { setCurrentWorkspaceObject,
        setDeletedWorkspaceObject,
        setWorkspaceObjects, workspaceObjects, getAdditionalResource } = useWorkspaceContext();
    const { occurrence } = props;
 
    function onProperties(): void {
        setCurrentWorkspaceObject({ objectType: ResourceType.OCCURRENCE_REPORTS, object: occurrence });
    }

    function onDelete(): void {
        setConfirmDeleteOccurrence(true);
    }

    function onDuplicate(): void {
        setConfirmDuplicateOccurrence(true);
    }

    function canEditOccurrence(): boolean {
        const groups = getAdditionalResource(ResourceType.GROUPS).resources;
        const group = groups?.find((grp) => grp.id === occurrence.group.id );
        return group?.canEdit();
    }

    return (
        <Box tabIndex={0}  onClick={(event: any): void => {
            event.stopPropagation();
        }}>
            <DotdotdotButton>
                <MenuItem id='properties' onClick={onProperties}>Properties</MenuItem>
                <MenuItem id='duplicate' onClick={onDuplicate}>Duplicate</MenuItem>
                {
                    canEditOccurrence() && <Divider /> && <MenuItem id='delete' onClick={onDelete}>Delete</MenuItem>
                }
            </DotdotdotButton>
            <DeleteResource
                open={confirmDeleteOccurrence}
                resourceType={ResourceType.OCCURRENCE_REPORTS}
                resourceName={occurrence.displayName}
                subResources={'sub occurrences and resources'}
                handleDelete={(): void => {
                    OccurrenceService.deleteOccurrenceById(occurrence.id!).then(() => {
                        setDeletedWorkspaceObject({
                            objectType: ResourceType.OCCURRENCE_REPORTS,
                            id: occurrence.id!
                        });
                        setWorkspaceObjects({ objectType: workspaceObjects?.objectType ?? ResourceType.GROUPS });
                    }).catch((error) => {
                        toast.error(error.message);
                    }).finally(() => {
                        setConfirmDeleteOccurrence(false);
                    });

                }}
                onClose={(): void => {
                    setConfirmDeleteOccurrence(false);
                }}
            />
            <DuplicateResource
                open={confirmDuplicateOccurrence}
                title={'Duplicate Occurrence - ' + occurrence.displayName}
                onClose={(): void => { setConfirmDuplicateOccurrence(false); }}
                onConfirm={
                    (id: number): void => {
                        let targetGroupId = id > 0 ? id : undefined;
                        let sourceOccurrenceId = occurrence.id;
                        setConfirmDuplicateOccurrence(false);
                        OccurrenceService.duplicateOccurrence(sourceOccurrenceId!, targetGroupId).then((response) => {
                            setWorkspaceObjects({ objectType: ResourceType.OCCURRENCE_REPORTS });
                            toast.info(response.data.displayName + ' duplicated successfully');
                        }).catch((error) => {
                            toast.error(error.message);
                        });
                    }
                }
                object={{objectType: ResourceType.OCCURRENCE_REPORTS, object: occurrence}}
                data={getAdditionalResource(ResourceType.GROUPS)}
            />
        </Box>
    );
}
